// extracted by mini-css-extract-plugin
export default {"previewTable":"ReportGeneralPreview_previewTable__WJFpd"};